import {
  AvatarRow,
  Divider,
  InputRow,
  PageWrapper,
} from '@components/Dashboard/components'
import { useWorkspaces } from '@components/Dashboard/hooks'
import type { ID } from '@octopus-do/octopus-project-core'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import { clsJoin } from '@/utils'
import { AvatarButton, MembersCard, PlanCard } from './components'
import { useWorkspaceActions } from './hooks'
import css from './styles.module.css'

export const TeamSettings: React.FC = () => {
  const { current } = useWorkspaces()

  const avatarLoading = useSelector(selectIsLoading('team_avatar_upload'))

  const { onRename, onPlanClick, onSetAvatar, onAvatarRemove } =
    useWorkspaceActions(current?.id as ID)

  if (!current || !current.features.includes('team_settings')) {
    return null
  }

  return (
    <div className={clsJoin(css.responsive, css.content)}>
      <PageWrapper title="Team settings">
        <InputRow onChange={onRename} value={current.title} title="Team name" />

        <Divider />

        <AvatarRow onUpload={onSetAvatar} onDelete={onAvatarRemove}>
          <AvatarButton loading={avatarLoading} url={current.avatar} />
        </AvatarRow>
      </PageWrapper>

      {!current.expired && <MembersCard workspaceId={current.id} />}

      <PlanCard onClick={onPlanClick} />
    </div>
  )
}
